import React from 'react';

const SliderNextArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="0 0 34 24" fill="none">
      <path
        d="M1.44379 12.0135H32.5549M32.5549 12.0135L21.4438 0.902344M32.5549 12.0135L21.4438 23.1246"
        stroke="currentColor"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SliderNextArrow;
